import { render, staticRenderFns } from "./ProjectTasksDraw.vue?vue&type=template&id=6d2f9333"
import script from "./ProjectTasksDraw.vue?vue&type=script&lang=js"
export * from "./ProjectTasksDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports